<template>
  <div>
    <b-modal
      
      :hide-footer="true"
      content-class="modal-blue"
      id="choose-times-modal"
      
      size="xl"
    >
 
      <div class="row text-white justify-content-center" v-if="contractData.length>0">
        <!--!alreadyChosenTimes-->

              <div class="col-12" style='color: white !important;' v-if="contractData[0].contract_approved==1">

<p v-if="contractData[0].currencyID==2">We wish you good luck and look forward to seeing you.</p>
<p v-if="contractData[0].currencyID==1">გისურვებთ წარმატებას და მოუთმენლად ველით თქვენს ნახვას.</p>
<p><br></p>
        </div>
    

        <!--div class="col-6">
          <div class="picker" v-if="!alreadyChosenTimes">
            <h2>Choose a Day , Time & Branch</h2>             

                <p class="text-center">Choose Branch</p>
            <div class="row">
              <div class="col-12 col-md-6">

                 <button
               
               
                class="btn m-1"
                :class="'Building 4 (Kostava M. 77a)' === selectedBranch ? 'btn-primary' : 'btn-outline-light'"
                @click="selectedBranch = 'Building 4 (Kostava M. 77a)'"
              >
               Building 4 (Kostava M. 77a)
              </button>


              </div>
              <div class="col-12 col-md-6">
                  <button
               
               
                class="btn m-1"
                :class="'P. Kavtaradze street, 4 Lane, 21 a' === selectedBranch ? 'btn-primary' : 'btn-outline-light'"
                @click="selectedBranch = 'P. Kavtaradze street, 4 Lane, 21 a'"
              >
               P. Kavtaradze street, 4 Lane, 21 a
              </button>

              </div>
            </div>

              

          
            <label>Select Date:</label>
                    <flat-pickr
            ref="datepicker"
            v-model="selectedDate"
            :config="dateConfig"
            class="form-control"
            placeholder="Pick a date"
          />

            <div v-if="selectedDate">
           
            <label class="mt-3">Select Time:</label>
            <div v-if="availableSlots.length" class="d-flex flex-wrap">
              <button
                v-for="slot in availableSlots"
                :key="slot"
                class="btn m-1"
                :class="slot === selectedTime ? 'btn-primary' : 'btn-outline-light'"
                @click="selectedTime = slot"
              >
                {{ slot }}
              </button>
            </div>
        
            </div>

           
            <div class="d-grid mt-5">
              <button class="btn btn-outline-danger" @click="saveChosenDateAndTime">
                Save
              </button>
            </div>           
            
          </div>
          <div v-else>Your scheduled visit time to the front office (Address: {{ alreadyChosenTimes[0].selectedBranch }})  to sign the contract is: {{alreadyChosenTimes[0].date}} - {{ alreadyChosenTimes[0].start+' - '+alreadyChosenTimes[0].end }}.    
            
            




            <button 
              class="btn btn-sm btn-danger ml-2"
              @click="removeChosenTime(alreadyChosenTimes[0].studentComeDateID)"
            >
              Delete and Choose New Slot
            </button>   
            
            <p v-if="contractData[0].contract_approved==1">
               Please download this application to access the university grounds. You will be able to activate it during your visit to the Front Office.<br>
              <br> 
                <table>
                  <tr>
                    <td>IOS</td>
                    <td>Android</td>
                  </tr>
                  <tr>
                    <td>
                      <a href="https://apps.apple.com/ge/app/sigur-access/id1436587535">
                        <img src="https://registration.ug.edu.ge/ios.png" alt="ios" width="150">   
                      </a>              
                    </td>
                    <td>                      
                      <a href="https://play.google.com/store/apps/details?id=com.sigursys.accessapp&hl=en&pli=1">
                         <img src="https://registration.ug.edu.ge/android.png" alt="android" width="150"> 
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">After downloading, follow the instructions below to activate the application</td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      <a href="http://mrid.sigursys.com/?013E99245E471877B434094F65BD9C5C65DDB13EB6239D0FF42D48DC8AD733312AAC16BD460E67CD73129CDEC8A1C8FF07CE1E7AF1357112D15C18BDB2B5C6F24ACE146487471873A09B58DADFDEAB92E391A00E9286695B7A3D6B5CBA29CCB23A4A6C17E7">
                      <img src="https://registration.ug.edu.ge/thumbnail_image.png" alt="activate" width="150">
                      </a>
                    </td>
                  </tr>
                </table>

            </p>

          </div>           
        </div-->

<!--alreadyChosenTimes-->
        <div class="col-12 text-left" v-if="contractData[0].contract_approved==0 && contractData[0].currencyID==2">
          <p class="text-center">University of Georgia  - The Student Contract</p>
<p>The University of Georgia LTD (the &ldquo;UG&rdquo;) represented by the Rector, Konstantine Topuria, and the student {{ contractData[0].fnameeng }} {{ contractData[0].lnameeng }} , passport number {{ contractData[0].personal_code }}, agree on the following:</p>
            <p><strong>1. The objective of the Agreement</strong></p>
            <p>1.1. UG offers to student accredited educational program {{ contractData[0].specialityeng }}</p>
            <p>1.2. UG confers a Diploma to successful graduates.</p>
            <p><strong>2. UG&rsquo;s Obligations:</strong></p>
            <p>UG is obliged to:</p>
            <p>2.1. Enroll International students at The University of Georgia on the {{ contractData[0].specialityeng }} Program.</p>
            <p>2.2. Provide student with the tuition and learning support facilities and other services associated with the programs with the reasonable care and skill, subject to this Agreement.</p>
            <p>2.3. Timely introduce UG&rsquo;s written regulations, rules, policies and procedures and inform the Student of his/her obligation to comply with such regulations and rules, which is available on UG&rsquo;s official web-page (<a href="http://www.ug.edu.ge">www.ug.edu.ge</a>).</p>
            <p>2.4 The procedures governing student registration, enrollment, the conclusion of contracts, as well as the rules and conditions for tuition fee reimbursement, shall be regulated by the rules on the Admission of Students without Unified National Examinations and/or Unified Graduate Examinations. (www.ug.edu.ge).</p>
            <p><strong>3. Student&rsquo;s Obligations</strong>:</p>
            <p>Student is obliged to:</p>
            <p>3.1. Comply with the obligations under this agreement in accordance with any reasonable instructions issued to student from time to time, by or on behalf of UG.</p>
            <p>3.2. Protect the patients&rsquo; privacy rules during the practical activities (for the students of medical field).</p>
            <p>3.2. Regularly check information on the UG&rsquo;s website www.ug.edu.ge. Information sent over the UG&rsquo;s personal webpage (&ldquo;My UG&rdquo;) will be considered as official communication. All messages regarding the student&rsquo;s educational process the UG will send through the student&rsquo;s personal webpage.</p>
            <p><strong>4. Payment rules:</strong></p>
            <p>4.1. After presenting all registration documents, the contract between a student and the university will be signed that covers the whole duration of program.</p>
            <p>4.2. Tuition fee can be amended only in exceptional circumstances that are defined by the government.</p>
            <p>4.3. Tuition fee for the students who enrolled on the 2026-2027 academic year, is {{ contractData[0].fee }} USD Equivalent in GEL per year (includes 60 credits). If the student registers more than 60 credits per year, she/he is obliged to pay the relevant fees before the ending registration. Tuition fee should be paid in GEL or in USD (In the event that the payment is made from a foreign bank) in the bank account provided by the financial department. In the case of payment of the tuition fee in Georgian Lari (GEL), the payment shall be made in accordance with the official exchange rate established by the National Bank of Georgia on the date of payment.</p>
            <p>4.4 The tuition fee does not cover insurance costs. Within one (1) month from the signing of the Agreement, the Student shall be obliged to submit to the University a health insurance policy issued for a minimum period of one year. Furthermore, prior to the expiry of the policy, the Student shall be obliged to provide the University with an annually renewed health insurance policy covering the entire duration of the Student’s studies.</p>
            <p>4.5 The tuition fee for the first academic year shall be paid as follows: The obligation to pay the annual tuition fee for the first academic year shall arise for the Student prior to the conclusion of the Agreement. In the event that the Student has already paid the initial installment of USD 1,000, such amount shall be credited towards the tuition fee.</p>
            <p>4.6 Starting from the second academic year and for each subsequent year, the annual tuition fee shall be paid by the student in two semester-based installments. The first installment, amounting to 50% of the annual tuition fee, shall be paid <strong>no later than </strong><strong>15</strong><strong> July</strong>, and the second installment, covering the remaining 50% of the annual tuition fee, shall be paid <strong>no later than </strong><strong>15</strong><strong> January.</strong> non-payment of tuition fee is basis of suspending of student&rsquo;s status..</p>
            <p>4.7 In the event that, at the stage of application submission, the Student has paid a fee for the University&rsquo;s support and involvement in carrying out the procedures required for obtaining the right to study, such service fee shall not constitute part of the tuition fee and shall be non-refundable. The amount of the service fee is determined in accordance with the &lsquo;Regulation on Admission of Students without Unified National Examinations and/or Unified Master&rsquo;s Examination&rsquo;.</p>
            <p>4.8 Tuition fees may be paid either by bank transfer (an invoice and/or account number will be provided on the registration link) or by card. In the case of a bank transfer, the candidate shall be obliged to upload the payment receipt.</p>
            <p><strong>5.&nbsp; Regulation on the Retention and Refund of Tuition Fees</strong></p>
            <p>5.1 The tuition fee paid by students for the first academic year shall be non-refundable, except in the exceptional circumstances provided under Article 5.5 of the present Agreement. From the second and subsequent academic years, the tuition fee shall be refunded to the student if his/her student status is terminated and/or the student applies to the University for termination of status, as follows:</p>
            <p>(a) Prior to the commencement of the academic year &ndash; the University shall retain the tuition fee available on the student&rsquo;s balance, but not exceeding 30% of the annual tuition fee;</p>
            <p>(b) Within four (4) weeks from the commencement of the academic year &ndash; the University shall retain the tuition fee available on the student&rsquo;s balance, but not exceeding 50% of the annual tuition fee;</p>
            <p>(c) Prior to the commencement of the second semester &ndash; the University shall retain the tuition fee available on the student&rsquo;s balance, but not exceeding 75% of the annual tuition fee.</p>
            <p>5.2 In cases of termination of the student&rsquo;s status due to the expiration of the five- or ten-year suspension period, the tuition fee available on the student&rsquo;s balance shall be refunded in accordance with Article 5.3.</p>
            <p>5.3 The refundable amount of the tuition fee shall be determined based on the stage at which the student&rsquo;s status was suspended. If the student&rsquo;s status is suspended and/or the student applies to the University for suspension of status:</p>
            <p>(a) Prior to the commencement of the academic year &ndash; the University shall retain the tuition fee available on the student&rsquo;s balance, but not exceeding 30% of the annual tuition fee;</p>
            <p>(b) Within four (4) weeks from the commencement of the academic year &ndash; the University shall retain the tuition fee available on the student&rsquo;s balance, but not exceeding 50% of the annual tuition fee;</p>
            <p>(c) Prior to the commencement of the second semester &ndash; the University shall retain the tuition fee available on the student&rsquo;s balance, but not exceeding 75% of the annual tuition fee.</p>
            <p>5.4 In cases of termination of the student&rsquo;s status on the grounds stipulated by the University&rsquo;s Code of Honor, the tuition fee available on the student&rsquo;s balance shall not be refunded.</p>
            <p>5.5 Exceptionally, the tuition fee paid by the Student for the first academic year shall be refunded, upon the Student&rsquo;s submission of an application for termination of status, provided that one of the following conditions is met:</p>
            <p>(a) If the Student submits to the University the decision of the Ministry of Foreign Affairs of Georgia confirming the refusal to issue a Georgian visa and/or the decision of the Ministry of Internal Affairs confirming the refusal of border crossing, and the Student has not completed academic registration. In such a case, the tuition fee paid for the first academic year shall be refunded in full, except for USD 300.</p>
            <p>&nbsp;</p>
            <p>(b) If the Student submits to the University the decision of the Legal Entity of Public Law &ndash; Public Service Development Agency confirming the refusal to issue a residence permit, and the Student has completed</p>
            <p>academic registration. In such a case, the tuition fee paid for the first academic year shall be refunded depending on the time when the aforementioned documents were submitted, specifically:</p>
            <p>(b.a) Prior to the commencement of the academic year &ndash; the University shall retain the tuition fee available on the Student&rsquo;s balance, but not exceeding 30% of the annual tuition fee;</p>
            <p>(b.b) Prior to the commencement of academic registration for the second semester &ndash; the University shall retain the tuition fee available on the Student&rsquo;s balance, but not exceeding 50% of the annual tuition fee.</p>
            <p>(c) If the Student does not sign the Agreement, in such a case, the tuition fee paid for the first academic year shall be refunded in full, except for the initial installment of USD 1,000.</p>
            <p><strong>6. Choice of law</strong></p>
            <p>6.1. All the amendments made to this Agreement are in force in case if they are accepted and signed by parties.</p>
            <p>6.2. This agreement shall be governed and construed in all respects in accordance with the Georgian Legislation.</p>
            <p><strong>7</strong>. <strong>Consent to the Processing of Student&rsquo;s Personal Data</strong></p>
            <p>7.1. By signing the agreement, the student declares his/her consent for the University to process their personal data, which may include details such as full name; personal number; identification document series and number; validity period of identification document; photograph; telephone number; e-mail address; date of birth; knowledge of foreign languages; gender; education-related information; citizenship; information concerning military obligations; copy/extract of student ID card; all legal acts defining student status (enrollment order, suspension, reinstatement); health-related information; copy of the order issued by the Ministry of Education and Science of Georgia granting the right to study, as required by law; data on entry/exit to and from the university premises.</p>
            <p>7.2 Purposes of Data Processing:</p>
            <p>&bull;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Compliance with requirements established by law and regulations;</p>
            <p>&bull;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Provision of educational services;</p>
            <p>&bull;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Identification of the student;</p>
            <p>&bull;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Administration of university operations;</p>
            <p>&bull;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Financial administration (payments, granting of scholarships);</p>
            <p>&bull;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Matters related to compulsory military service;</p>
            <p>&bull;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Compliance with reporting requirements prescribed by law;</p>
            <p>&bull;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Submission of information to relevant banking institutions for the purpose of opening bank accounts;</p>
            <p>&bull;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Security and protection of University property;</p>
            <p>&bull;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Statistical purposes;</p>
            <p>&bull;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Ensuring the participation of students in events organized by the University;</p>
            <p>&bull;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Creation of electronic accounts necessary for the implementation of the educational program;</p>
            <p>7.2. The student has the right to request information regarding the acquisition, storage, and processing of his/her personal data, as well as to request correction, updating, supplementation, blocking, deletion, or destruction of such data. The right to block, delete, or destroy shall not extend to those data whose retention and processing are necessary for the purposes of this Agreement and/or under applicable law.</p>
            <p>7.3 Personal data shall be retained by the University for three (3) years after the exhaustion of the specific purpose, except for health certificates submitted for special purposes (e.g., examination rescheduling), which shall be retained for one (1) month after the end of the relevant semester. Consent shall encompass any active and/or passive form of action performed on the personal data, including video and audio monitoring.</p>
            <p>7.4 The University may process personal data (including special category data) through automated, semi-automated, or non-automated means.</p>
            <p>7.5 For any questions, comments, requests, or claims arising out of or in connection with this document, please contact us at:E-mail: <a href="mailto:info@ug.edu.ge">info@ug.edu.ge</a> , Tel: +995 32 2 55 22 22.</p>
            <p>7.6 The consent to the processing of personal data for the purposes of direct marketing <strong>(Annex N1),</strong> as well as the Student&rsquo;s consent to the publication by the University, on its official website and/or social media platforms, of photo, video, or audio materials containing the Student&rsquo;s image recorded in the course of the educational process (<strong>Annex N2</strong>), the acceptance or refusal of which shall be exercised by the Student electronically via the <strong>my.ug</strong> online portal, shall constitute an integral part of the Agreement.</p>
            <p><strong>8. The additional conditions to the contract</strong></p>
            <p>8.1. This agreement is made 2 copies in English language and both have equal legal force.</p>
            <p>8.2. The 'University' is authorized to make unilaterally changes to the Educational Program and UG Regulations, and the 'Student' must be informed in a timely manner.</p>
            <p>8.3. Tuition fee does not cover the cost of participating in the graduation ceremony.</p>


            <div class="text-center" v-if="contractData[0].contract_approved==0">
              <button 
              class="btn btn-sm btn-success ml-2"
              @click="approveContract(contractData[0].studentID)"
            >
              Accept
            </button>
            </div>

        </div>






          <div class="col-12 text-left" v-if="contractData[0].contract_approved==0 && contractData[0].currencyID==1 && contractData[0].study_levelID==1">


              <div style="font-size:12px !important;width: 250mm;   /* A4 width */min-height: 297mm; /* A4 height */padding:5mm 20mm;" id="contract">
                <p align="center">საქართველოს უნივერსიტეტი<br />
                    ხელშეკრულება სტუდენტთან</p>
                <p align="center">ქ. თბილისი                                                                                                                    <br />
                </p>
                <p>ერთის მხრივ, შეზღუდული პასუხისმგებლობის საზოგადოება “საქართველოს უნივერსიტეტი”, წარმოდგენილი რექტორის კონსტანტინე  თოფურიას სახით (შემდეგში “უნივერსიტეტი”) და მეორეს მხრივ,  {{ contractData[0].fname }} {{ contractData[0].lname }}
                    (შემდეგში “აბიტურიენტი’’/“სტუდენტი’’), გამომდინარე იმ გარემოებიდან, რომ „აბიტურიენტს“, საქართველოს განათლებისა და მეცნიერების მინისტრის 2011 წლის 29 დეკემბრის №224/ნ ბრძანებით დამტკიცებული წესის შესაბამისად, ერთიანი ეროვნული გამოცდების გავლის გარეშე მიენიჭა „უნივერსიტეტის“ {{ contractData[0].school }} {{ contractData[0].speciality }} საგანმანათლებლო პროგრამაზე (შემდგომში — „საგანმანათლებლო პროგრამა“) სწავლის უფლება, მხარეები თანხმდებიან შემდეგზე:
                </p>
                <p><strong>1. “უნივერსიტეტი” ვალდებულია:</strong></p>
                <p>1.1. საქართველოს უნივერსიტეტის საბაკალავრო სწავლების დებულებით (შემდეგში “დებულება’’) დადგენილი საგანმანათლებლო პროგრამაზე ჩარიცხვის წინაპირობების დაკმაყოფილების საფუძველზე ჩარიცხოს “აბიტურიენტი’’ “საგანმანათლებლო პროგრამაზე’’. </p>
                <p>1.2. უზრუნველყოს სასწავლო პროცესი შესაბამისი აკადემიური პერსონალითა და მატერიალურ-ტექნიკური ბაზით. </p>
                <p>1.3. “სტუდენტის’’სწავლება და მისი სწავლის შედეგების შეფასება განახორციელოს მოქმედი კანონმდებლობის, „საგანმანათლებლო პროგრამისა“ და უნივერსიტეტის შიდა სამართლებრივი აქტებით განსაზღვრული პირობების შესაბამისად.</p>
                <p>1.4. „საგანმანათლებლო პროგრამის“ დასრულებისა და შესაბამისი აკადემიური ხარისხის მინიჭებისთვის დადგენილი მოთხოვნების შესრულების შემთხვევაში მიანიჭოს „სტუდენტს“ შესაბამისი აკადემიური ხარისხი და გასცეს მისი დამადასტურებელი დიპლომი.</p>
                <p><strong>2. “სტუდენტი” ვალდებულია: </strong></p>
                <p>2.1. გაეცნოს და დაიცვას საუნივერსიტეტო რეგულაციები, მათ შორის, ღირსების კოდექსი და „დებულება“, რომელიც ასევე აწესრიგებს უნივერსიტეტსა და სტუდენტს შორის ურთიერთობას.</p>
                <p>2.2. ერთი სასწავლო წლის (60 კრედიტი) საფასური 2026/2027 სასწავლო წელს ჩარიცხული “სტუდენტისთვის’’ განისაზღვრება {{ contractData[0].fee }} ლარით.  წლიურად დამატებითი კრედიტების დარეგისტრირების შემთხვევაში, სტუდენტი ვალდებულია გადაიხადოს შესაბამისი საფასური რეგისტრაციის დასრულებამდე. </p>
                <p>2.3. სწავლის საფასურის გადახდის ვადები და პირობები განისაზღვრება „დებულებით“. სწავლის საფასურის დადგენილ ვადაში გადაუხდელობა წარმოადგენს სტუდენტის სტატუსის შეჩერების საფუძველს „დებულებითა“ და მოქმედი კანონმდებლობით განსაზღვრული წესით.</p>
                <p>2.4. სისტემატურად გაეცნოს “უნივერსიტეტის’’ ოფიციალურ ვებ-გვერდსა (www.ug.edu.ge) და სტუდენტის პერსონალურ გვერდს “ჩემი UG”. </p>
                <p><strong>3. ხელშეკრულების მოქმედების ვადა და შეწყვეტის წესი </strong></p>
                <p>3.1 ხელშეკრულება ძალაში შედის მხარეთა მიერ ხელმოწერისთანავე და მოქმედებს სტუდენტის მიერ საგანმანათლებლო პროგრამის დასრულებამდე ან წინამდებარე ხელშეკრულების, „დებულებისა“ და მოქმედი კანონმდებლობის შესაბამისად ხელშეკრულების ვადამდე შეწყვეტამდე.</p>
                <p>3.2. ხელშეკრულების ვადამდე შეწყვეტის საფუძვლები და წესი განისაზღვრება „დებულებით“, წინამდებარე ხელშეკრულებითა და მოქმედი კანონმდებლობით.</p>
                <p>4. ხელშეკრულების დამატებითი პირობები </p>
                <p>4.1. მხარეები თანხმდებიან, რომ “უნივერსიტეტის’’ მიერ “ჩემი UG”-ზე გაგზავნილი შეტყობინება ითვლება “სტუდენტისათვის“ გაგზავნილ ოფიციალურ </p>
                <p>4.2. უნივერსიტეტი უფლებამოსილია მოქმედი კანონმდებლობითა და უნივერსიტეტის შიდა სამართლებრივი აქტებით დადგენილი წესით შეიტანოს ცვლილებები „საგანმანათლებლო პროგრამასა“ და „დებულებაში“. ისეთი ცვლილების შესახებ, რომელიც გავლენას ახდენს სტუდენტის სასწავლო პროცესზე ან მის უფლებებსა და ვალდებულებებზე, სტუდენტს ინფორმაცია მიეწოდება დროულად.</p>
                <p>4.3. “სტუდენტი’’ თანხმობას აცხადებს, რომ შპს “საქართველოს უნივერსიტეტმა’’ საგანმანათლებლო საქმიანობიდან გამომდინარე მომსახურების გამარტივებისა და გაუმჯობესების, ასევე, საბანკო დაწესებულებებთან ურთიერთობის გამარტივების მიზნით, გამოითხოვოს (დაამუშაოს მონაცემები) სსიპ სახელმწიფო სერვისების განვითარების სააგენტოს მონაცემთა ელექტრონულ ბაზაში დაცული პირადობის დამადასტურებელი დოკუმენტის, რეგისტრაციისა და მათი სტატუსების შესახებ ინფორმაციის თაობაზე, “სტუდენტის’’ პერსონალური მონაცემები. “სტუდენტი’’ ადასტურებს, რომ ინფორმირებულია „პერსონალურ მონაცემთა დაცვის შესახებ“ საქართველოს კანონით მისთვის მინიჭებული უფლებამოსილებების შესახებ. “სტუდენტი’’ თანახმაა, “უნივერსიტეტმა’’ მის შესახებ ინფორმაცია განათავსოს უნივერსიტეტის სტუდენტურ ბაზაში “ჩემი UG”. </p>
                <p>4.4 ხელშეკრულებაზე ხელმოწერით სტუდენტი აცხადებს რომ  თანახმაა  საგანმანათლებლო პროცესში გადაღებული მისი გამოსახულების შემცველი ფოტო/ვიდეო მასალა უნივერსტეტმა განათავსოს მის ოფიციალურ  ვებ-გვერდზე/სოციალურ ქსელში, ამასთანავე სტუდენტისთვის ცნობილია, რომ ნებისმიერ დროს, ყოველგვარი განმარტების ან დასაბუთების გარეშე უფლება აქვს გაიხმოს მის მიერ გაცემული თანხმობა.</p>
                <p>4.5  ხელშეკრულებაზე ხელმოწერით „სტუდენტი“ ადასტურებს, რომ ინფორმირებულია მისი პერსონალური მონაცემების დამუშავების შესახებ და, კანონით გათვალისწინებულ შემთხვევებში, აცხადებს თანხმობას მათი დამუშავების თაობაზე. „უნივერსიტეტი“ უფლებამოსილია, „პერსონალურ მონაცემთა დაცვის შესახებ“ საქართველოს კანონისა და სხვა მოქმედი კანონმდებლობის შესაბამისად, შესაბამისი სამართლებრივი საფუძვლის არსებობისას, დაამუშაოს სტუდენტის პერსონალური მონაცემები, მათ შორის: სახელი, გვარი, პირადი ნომერი, პირადობის დამადასტურებელი დოკუმენტის სერია და ნომერი, პირადობის დამადასტურებელი დოკუმენტის მოქმედების ვადა, ფოტოსურათი, ტელეფონის ნომერი, ელექტრონული ფოსტის მისამართი, დაბადების თარიღი, უცხო ენის ცოდნის, სქესის, განათლების, მოქალაქეობისა და სამხედრო ვალდებულების შესახებ ინფორმაცია, სტუდენტის სასწავლო ბარათის ასლი ან მისი ამონაწერი, სტუდენტის სტატუსთან დაკავშირებული სამართლებრივი აქტები (მათ შორის, ჩარიცხვის, სტატუსის შეჩერების, აღდგენისა და შეწყვეტის შესახებ აქტები), კანონმდებლობის შესაბამისად სწავლების უფლების მინიჭების შესახებ საქართველოს განათლების, მეცნიერებისა და ახალგაზრდობის სამინისტროს შესაბამისი აქტის ასლი, აგრეთვე სხვა მონაცემები, რომელთა დამუშავებაც აუცილებელია საგანმანათლებლო პროცესის ადმინისტრირების, სტუდენტის სტატუსთან დაკავშირებული პროცედურების განხორციელების, სტუდენტისთვის საგანმანათლებლო მომსახურების გაწევის, წინამდებარე ხელშეკრულებით გათვალისწინებული უფლებებისა და ვალდებულებების შესრულებისა და უნივერსიტეტისთვის მოქმედი კანონმდებლობით დაკისრებული ვალდებულებების შესრულების მიზნით.</p>
                <p>პერსონალური მონაცემების დამუშავება შეიძლება განხორციელდეს ავტომატური, ნახევრად ავტომატური ან არაავტომატური საშუალებებით.</p>
                <p>არასრულწლოვანი სტუდენტის პერსონალური მონაცემების დამუშავება ხორციელდება „პერსონალურ მონაცემთა დაცვის შესახებ“ საქართველოს კანონით არასრულწლოვნის მონაცემთა დამუშავებისთვის დადგენილი მოთხოვნების შესაბამისად.</p>
                <p>4.6 „სტუდენტს“, როგორც მონაცემთა სუბიექტს, აქვს „პერსონალურ მონაცემთა დაცვის შესახებ“ საქართველოს კანონით გათვალისწინებული უფლებები, მათ შორის, უფლება მიიღოს ინფორმაცია მისი პერსონალური მონაცემების დამუშავების შესახებ, გაეცნოს მის შესახებ არსებულ პერსონალურ მონაცემებს და მიიღოს მათი ასლები, აგრეთვე კანონით გათვალისწინებულ შემთხვევებში მოითხოვოს მონაცემების გასწორება, განახლება, შევსება, დამუშავების შეწყვეტა, წაშლა, განადგურება ან დაბლოკვა. აღნიშნული უფლებები ხორციელდება „პერსონალურ მონაცემთა დაცვის შესახებ“ საქართველოს კანონით დადგენილი პირობებისა და შეზღუდვების შესაბამისად.</p>
                <p>4.7. სწავლის საფასური არ მოიცავს დიპლომის გადაცემის საზეიმო ცერემონიალში მონაწილეობის საფასურს. </p>
                <p>4.8. ხელშეკრულება შედგენილია ორი თანაბარი იურიდიული ძალის მქონე ეგზემპლარად თითოეული ხელმომწერი მხარისათვის. </p>
                <p>4.9. დანართი №1 – „თანხმობა სტუდენტის პერსონალურ მონაცემთა დამუშავებაზე“ წარმოადგენს წინამდებარე ხელშეკრულების განუყოფელ ნაწილს. ხელშეკრულებაზე სტუდენტის მიერ ხელმოწერა მოიცავს ასევე დანართი №1-ით გათვალისწინებულ თანხმობას.</p>
                <p>4.10. პირდაპირი მარკეტინგის მიზნით პერსონალური მონაცემების დამუშავებაზე თანხმობა (დანართი №2), აგრეთვე სტუდენტის თანხმობა საგანმანათლებლო პროცესში გადაღებული მისი გამოსახულების შემცველი ფოტო/ვიდეო/აუდიო მასალის უნივერსიტეტის ოფიციალურ ვებგვერდზე ან/და სოციალურ ქსელში განთავსებაზე (დანართი №3) სტუდენტს მიეწოდება ელექტრონულად „my.UG“-ის ონლაინ პორტალის მეშვეობით. აღნიშნულ თანხმობებზე თანხმობის ან უარის დაფიქსირება სტუდენტის მიერ ხორციელდება ელექტრონულად „my.UG“-ის ონლაინ პორტალის მეშვეობით. დანართები №2 და №3 წარმოადგენს წინამდებარე ხელშეკრულების განუყოფელ ნაწილს.</p>
                <br><br><br>
                
 
            </div>




            <div class="text-center" v-if="contractData[0].contract_approved==0">
              <button 
              class="btn btn-sm btn-success ml-2"
              @click="approveContract(contractData[0].studentID)"
            >
              დადასტურება
            </button>
            </div>

        </div>


   <div class="col-12 text-left" v-if="contractData[0].contract_approved==0 && contractData[0].currencyID==1 && contractData[0].study_levelID==2">


              <div style="font-size:12px !important;width: 250mm;   /* A4 width */min-height: 297mm; /* A4 height */padding:5mm 20mm;" id="contract">
                <p align="center">საქართველოს უნივერსიტეტი<br />
                    ხელშეკრულება სტუდენტთან</p>
                <p align="center">ქ. თბილისი                                                                                                                   <br />
                </p>
                <p>ერთის მხრივ, შეზღუდული პასუხისმგებლობის საზოგადოება “საქართველოს უნივერსიტეტი”, წარმოდგენილი რექტორის კონსტანტინე  თოფურიას სახით (შემდეგში “უნივერსიტეტი”) და მეორეს მხრივ, {{ contractData[0].fname }} {{ contractData[0].lname }}
                    (შემდეგში „მაგისტრანტობის კანდიდატი“/“სტუდენტი’’), გამომდინარე იმ გარემოებიდან, რომ „მაგისტრანტობის კანდიდატს“, საქართველოს განათლებისა და მეცნიერების მინისტრის 2011 წლის 29 დეკემბრის №224/ნ ბრძანებით დამტკიცებული წესის შესაბამისად, საერთო სამაგისტრო გამოცდის გავლის გარეშე მიენიჭა „უნივერსიტეტის“ {{ contractData[0].school }} {{ contractData[0].speciality }} სამაგისტრო საგანმანათლებლო პროგრამაზე სწავლის უფლება
                      <span v-if="contractData[0].concentration">
                                                , კონცენტრაცია  {{ contractData[0].concentration }}
                                                </span>
                    
                    (შემდგომში — „მაგისტრატურა“), მხარეები თანხმდებიან შემდეგზე:
                </p>
                <p><strong>1. “უნივერსიტეტი” ვალდებულია:</strong></p>
                <p>1.1. საქართველოს უნივერსიტეტის საბაკალავრო და სამაგისტრო სწავლების დებულებებით (შემდეგში “დებულება’’) დადგენილი საგანმანათლებლო პროგრამაზე ჩარიცხვის წინაპირობების დაკმაყოფილების საფუძველზე ჩარიცხოს „მაგისტრანტობის კანდიდატი“ „მაგისტრატურაში’.’</p>
                <p>1.2. უზრუნველყოს სასწავლო პროცესი შესაბამისი აკადემიური პერსონალითა და მატერიალურ-ტექნიკური ბაზით.</p>
                <p>1.3. “სტუდენტის’’ სწავლება და მისი ცოდნის შეფასება განახორციელოს საქართველოს განათლებისა და მეცნიერების სამინისტროს მიერ დადგენილი სტანდარტების საფუძველზე შემუშავებული „დებულების“ და უნივერსიტეტის აქტებით განსაზღვრული პირობების შესაბამისად.</p>
                <p>1.4. საგანმანათლებლო პროგრამის დასრულების შემდეგ მიანიჭოს “სტუდენტს’’ შესაბამისი აკადემიური ხარისხი და გასცეს მინიჭებული აკადემიური ხარისხის დამადასტურებელი დიპლომი.</p>
                <p><strong>2. “სტუდენტი” ვალდებულია:</strong></p>
                <p>2.1. გაეცნოს საუნივერსიტეტო რეგულაციებს, მათ შორის "ღირსების კოდექსსა" და "დებულებას", რომელიც ასევე აწესრიგებს “უნივერსიტეტსა’’ და “სტუდენტს’’ შორის ურთიერთობას.</p>
                <p>2.2. პირველ სემესტრში დარეგისტრირდეს საგანმანათლებლო პროგრამით გათვალისწინებულ  მინიმუმ 18 კრედიტზე და გადაიხადოს შესაბამისი ოდენობის თანხა; </p>
                <p>2.3. უნივერსიტეტის {{ contractData[0].school }}ში, {{ contractData[0].speciality }} სამაგისტრო საგანმანათლებლო პროგრამაზე სწავლის საფასური 2026/2027 სასწავლო წელს ჩარიცხული სტუდენტისთვის განისაზღვრება ჯამში {{ contractData[0].fee }} ლარით. ერთი სასწავლო წლის (60 კრედიტი)საფასური  შეადგენს {{ contractData[0].fee }} ლარს. </p>
                <p>2.4 დამატებითი კრედიტების დარეგისტრირების შემთხვევაში, სტუდენტი ვალდებულია გადაიხადოს შესაბამისი კრედიტების საფასური რექტორის ბრძანებით დადგენილი წესის შესაბამისად.</p>
                <p>2.5. სწავლის საფასური გადაიხადოს დებულებითა და რექტორის ბრძანებით განსაზღვრული წესის შესაბამისად. სწავლის საფასურის გადახდის ვადები განისაზღვრება “დებულებით’’. სწავლის საფასურის გადაუხდელობა სტუდენტის სტატუსის შეჩერების საფუძველია.</p>
                <p>2.6. პერიოდულად გაეცნოს “უნივერსიტეტის’’ ოფიციალურ ვებ-გვერდსა (www.ug.edu.ge) და სტუდენტის პერსონალურ გვერდს “ჩემი UG”.</p>
                <p><strong>3. ხელშეკრულების მოქმედების ვადა და შეწყვეტის წესი</strong></p>
                <p>3.1. ხელშეკრულება ძალაშია მხარეთა მიერ ხელმოწერისთანავე და მოქმედებს “საგანმანათლებლო პროგრამით’’ განსაზღვრული სწავლების მთელი დროის განმავლობაში ამ ხელშეკრულებით განსაზღვრული პირობების გათვალისწინებით.</p>
                <p>3.2. ხელშეკრულების ვადამდე შეწყვეტის შემთხვევებს არეგულირებს “დებულება’’.</p>
                <p><strong>4. ხელშეკრულების დამატებითი პირობები</strong></p>
                <p>4.1. მხარეები თანხმდებიან, რომ “უნივერსიტეტის’’ მიერ “ჩემი UG”-ზე გაგზავნილი შეტყობინება ითვლება “სტუდენტისათვის“ გაგზავნილ ოფიციალურ შეტყობინებად.</p>
                <p>4.2. “უნივერსიტეტი’’ უფლებამოსილია ცალმხრივად შეიტანოს ცვლილებები საგანმანათლებლო პროგრამაში და “დებულებაში’’. ამასთან, “სტუდენტის’’ ინფორმირება უნდა მოხდეს დროულად.</p>
                <p>4.3. “სტუდენტი’’ თანხმობას აცხადებს, რომ შპს “საქართველოს უნივერსიტეტმა’’ საგანმანათლებლო საქმიანობიდან გამომდინარე მომსახურების გამარტივებისა და გაუმჯობესების, ასევე, საბანკო დაწესებულებებთან ურთიერთობის გამარტივების მიზნით, გამოითხოვოს (დაამუშაოს მონაცემები) სსიპ სახელმწიფო სერვისების განვითარების სააგენტოს მონაცემთა ელექტრონულ ბაზაში დაცული პირადობის დამადასტურებელი დოკუმენტის, რეგისტრაციისა და მათი სტატუსების შესახებ ინფორმაციის თაობაზე, “სტუდენტის’’ პერსონალური მონაცემები. “სტუდენტი’’ ადასტურებს, რომ ინფორმირებულია „პერსონალურ მონაცემთა დაცვის შესახებ“ საქართველოს კანონით მისთვის მინიჭებული უფლებამოსილებების შესახებ. “სტუდენტი’’ თანახმაა, “უნივერსიტეტმა’’ მის შესახებ ინფორმაცია განათავსოს უნივერსიტეტის სტუდენტურ ბაზაში “ჩემი UG”.</p>
                <p>4.4 ხელშეკრულებაზე ხელმოწერით სტუდენტი აცხადებს თანხმობას მისი პერსონალური მონაცემები (სახელი, გვარი, პირადი ნომერი, პირადობის დამადასტურებელი დოკუმენტის სერია და ნომერი, პირადობის დამადასტურებელი დოკუმენტის გაცემის ვადა, ფოტოსურათი, ტელეფონის ნომერი, ელექტრონული ფოსტის მისამართი, დაბადების  თარიღი,   უცხო   ენის   ცოდნა,   სქესი,   განათლების  შესახებ   ინფორმაცია, მოქალაქეობა, სამხედრო ვალდებულების შესახებ  ინფორმაცია, სტუდენტის სასწავლო ბარათის ასლი ან მისი ამონაწერი, სტუდენტის სტატუსის განმსაზღვრელი ყველა სამართლებრივი აქტის/აქტები (ჩარიცხვის ბრძანება, სტატუსის შეჩერება, აღდგენა, შეწყვეტა), კანონმდებლობის შესაბამისად სწავლების უფლების მინიჭებაზე საქართველოს განათლების,მეცნიერების და ახალგაზრდობის სამინისტროს ბრძანების ასლი) უნივერსტეტმა დაამუშაოს საგანმანათლებლო მიზნებისათვის ავტომატური, ნახევრად ავტომატური ან არაავტომატური საშუალებების გამოყენებით სტუდენტის პერსონალური მონაცემები (განსაკუთრებული კატეგორიის მონაცემების დამუშავების შემთხვევაში საჭიროა კანონიერი წარმომადგენლის თანხმობა), წინამდებარე ხელშეკრულებით გათვალისწინებული მომსახურების ფარგლებში მხარეების უფლებებისა და ვალდებულებების სრულად და ჯეროვნად შესრულების უზრუნველყოფის მიზნით  (დანართი N1).</p>
                <p>4.5 სტუდენტი უფლებამოსილია მოითხოვოს ინფორმაცია მისი პერსონალური მონაცემების მოპოვების, შენახვისა და დამუშავების შესახებ, აგრეთვე მოსთხოვოს უნივერსტეტს ამ მონაცემების გასწორება, განახლება, დამატება, დაბლოკვა, წაშლა და განადგურება. დაბლოკვის, წაშლისა და განადგურების მოთხოვნა არ ეხება ისეთ პერსონალურ მონაცემებს, რომლის შენახვა-დამუშავება აუცილებელია ამ ხელშეკრულების/კანონის მიზნებისთვის.</p>
                <p>4.6. სწავლის საფასური არ მოიცავს დიპლომის გადაცემის საზეიმო ცერემონიალში მონაწილეობის საფასურს.</p>
                <p>4.7. ხელშეკრულება შედგენილია ორი თანაბარი იურიდიული ძალის მქონე ეგზემპლარად თითოეული ხელმომწერი მხარისათვის.</p>
                <p>4.8 თანხმობა სტუდენტის პერსონალურ მონაცემთა დამუშავებაზე (დანართი N1), რომელზე თანხმობაც ხელშეკრულების დადების წინაპირობაა), თანხმობა პირდაპირი მარკეტინგის მიზნით პერსონალური მონაცემების დამუშვებაზე (დანართი N2), სტუდენტის თანხმობა საგანმანათლებლო პროცესში გადაღებული მისი გამოსახულების შემცველი ფოტო/ვიდეო/აუდიო მასალის უნივერსტეტის მიერ მის ოფიციალურ ვებ-გვერდზე/სოციალურ ქსელში განთავსების თაობაზე (დანართი N3), რომელზე თანხმობა/უარყოფას სტუდენტი ახორციელებს მასზე ხელმოწერით, წარმოადგენს ხელშეკრულების განუყოფელ ნაწილს.</p>
                <p>4.9. დანართი №1 – „თანხმობა სტუდენტის პერსონალურ მონაცემთა დამუშავებაზე“ წარმოადგენს წინამდებარე ხელშეკრულების განუყოფელ ნაწილს. ხელშეკრულებაზე სტუდენტის მიერ ხელმოწერა მოიცავს ასევე დანართი №1-ით გათვალისწინებულ თანხმობას.</p>
                <p>4.10. პირდაპირი მარკეტინგის მიზნით პერსონალური მონაცემების დამუშავებაზე თანხმობა (დანართი №2), აგრეთვე სტუდენტის თანხმობა საგანმანათლებლო პროცესში გადაღებული მისი გამოსახულების შემცველი ფოტო/ვიდეო/აუდიო მასალის უნივერსიტეტის ოფიციალურ ვებგვერდზე ან/და სოციალურ ქსელში განთავსებაზე (დანართი №3) სტუდენტს მიეწოდება ელექტრონულად „my.UG“-ის ონლაინ პორტალის მეშვეობით. აღნიშნულ თანხმობებზე თანხმობის ან უარის დაფიქსირება სტუდენტის მიერ ხორციელდება ელექტრონულად „my.UG“-ის ონლაინ პორტალის მეშვეობით. დანართები №2 და №3 წარმოადგენს წინამდებარე ხელშეკრულების განუყოფელ ნაწილს.</p>
                <br><br><br>
              

                
 
            </div>




            <div class="text-center" v-if="contractData[0].contract_approved==0">
              <button 
              class="btn btn-sm btn-success ml-2"
              @click="approveContract(contractData[0].studentID)"
            >
              დადასტურება
            </button>
            </div>

        </div>



      </div>
    </b-modal>
  </div>
</template>

<script>
import FlatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import ScheduleResource from "../api/scheduleResource";
const scheduleResource=new ScheduleResource()
export default {
  components: { FlatPickr },

  mounted(){


        scheduleResource.alreadyChosenTimes(1).then(response=>{
            //
            if(response.data.length>0){
              this.alreadyChosenTimes=response.data
            }           
        })

        scheduleResource.getInternationalData().then(response=>{
            
            this.contractData =response.data

        })

  },

 

  data() {
    return {
      selectedDate: null,
      selectedTime: "",
      availableTimes: {},
      availableSlots: [],
      alreadyChosenTimes:null,
      contractData:[],
      selectedBranch:null
    };
  },
 


  computed: {

dateConfig() {
  const dates = Object.keys(this.availableTimes);
  return {
    dateFormat: "Y-m-d",
    enable: dates,
    monthSelectorType: "static",
    minDate: dates.length ? dates[0] : null // ✅ only restricts, doesn’t reset
  };
}




  },
  watch: {
    selectedDate(newVal) {
      if (!newVal) {
        this.availableSlots = [];
        this.selectedTime = "";
        return;
      }

      // If Flatpickr gave us a Date object, format it
      if (Object.prototype.toString.call(newVal) === "[object Date]") {
        const picked = this.formatDate(newVal);
        this.availableSlots = this.availableTimes[picked] || [];
        this.selectedDate = picked; // overwrite with string version
      } else {
        // Already a string YYYY-MM-DD
        this.availableSlots = this.availableTimes[newVal] || [];
      }

      this.selectedTime = "";
    },
     selectedBranch(val){
      
      if(val){

        this.selectedDate=null
        this.selectedTime=""
        
        scheduleResource.getAvailableDatesAndTimes(val,1).then(response=>{
            
            this.availableTimes=response.data

        })


      }
    }
  },
  methods: {
    formatDate(dateObj) {
      const y = dateObj.getFullYear();
      const m = String(dateObj.getMonth() + 1).padStart(2, "0");
      const d = String(dateObj.getDate()).padStart(2, "0");
      return `${y}-${m}-${d}`;
    },
    saveChosenDateAndTime() {
      if (this.selectedDate && this.selectedTime && this.selectedBranch) {
    

            scheduleResource.saveChosenDateAndTime(this.selectedDate , this.selectedTime,this.selectedBranch,1).then(response=>{
                    
                    if(response.data=='ok'){
                        location.reload()
                    }else {

                        alert(`Time is not available`);
                    }
            })
    
    } else {
        alert("Please select date , time and branch");
      }
    },

    removeChosenTime(id) {
      scheduleResource.removeChosenTime(id)
            .then(() => {
              window.location.reload()
            });
    },
    approveContract(id){
      scheduleResource.approveContract(id)
      .then(() => {
              window.location.reload()
            });
    }
    ,
    forceRefreshMonth() {
    if (this.$refs.datepicker && this.$refs.datepicker.fp) {
      this.$refs.datepicker.fp.redraw(); // ✅ forces month/year label to update
    }
  }



  }
};
</script>

<style scoped>
.picker {
  font-family: Arial, sans-serif;
  padding: 20px;
  max-width: 400px;
}
label {
  font-weight: bold;
  display: block;
  margin-top: 15px;
}
button {
  min-width: 120px;
}
.summary {
  margin-top: 15px;
  background: #f5f5f5;
  padding: 10px;
  border-radius: 5px;
}



.flatpickr-monthDropdown-months,
.flatpickr-current-month select {
  position: relative;
  z-index: 99900000009 !important;
  background: #fff;
  color: #000;
}



</style>
